// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".details-container[data-v-825620aa]{display:flex;flex-wrap:wrap}p[data-v-825620aa]{font-size:1.25rem;margin-bottom:0}@media(min-width:768px){p[data-v-825620aa]{font-weight:300}}span[data-v-825620aa]{font-size:1.25rem;padding:0 4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
